import { Box, Typography, Paper, Stack } from "@mui/material";
import visa from "../../assets/cards/visa.png"; // Visa
import mastercard from "../../assets/cards/mastercard.png"; // Mastercard
import interac from "../../assets/cards/interac.png"; // Interac
import swift from "../../assets/cards/swift.png"; // SWIFT
import jcb from "../../assets/cards/jcb.png"; // JCB
import emanat from "../../assets/cards/emanat.png"; // eMonet
import sofort from "../../assets/cards/sofort.png"; // SOFORT
import trustly from "../../assets/cards/trustly.png"; // Trustly
import sepa from "../../assets/cards/sepa.png"; // SEPA
import Grid from '@mui/material/Grid2';

const CardProcessing = () => {
  // Data for payment methods sections
  const paymentSections = [
    {
      id: 1,
      title: "CARDS",
      methods: [
        [
          { image: visa, alt: "Visa", width: 90, height: 29 },
          { image: mastercard, alt: "Mastercard", width: 67, height: 52 },
        ],
        [
          { image: jcb, alt: "JCB", width: 81, height: 62 },
        ]
      ]
    },
    {
      id: 2,
      title: "BANK TRANSFERS",
      methods: [
        [
          { image: sepa, alt: "SEPA", width: 119, height: 49 },
        ],
        [
          { image: swift, alt: "SWIFT", width: 64, height: 64 },
          { image: interac, alt: "Interac", width: 61, height: 62 },
        ]
      ]
    },
    {
      id: 3,
      title: "ALTERNATIVE PAYMENT METHODS",
      methods: [
        [
          { image: trustly, alt: "Trustly", width: 128, height: 39 },
          { image: emanat, alt: "eMonet", width: 110, height: 38 },
        ],
        [
          { image: sofort, alt: "SOFORT", width: 149, height: 49 },
        ]
      ]
    }
  ];

  return (
    <Stack spacing={4} sx={{
        display: "flex",
        maxWidth: "1320px",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "0 20px",
        gap: "32px",
        width: "100%",
        
    }}>
      <Box sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: "10px",
        alignSelf: "stretch",
      }}>
        <Typography sx={{
            fontSize: {md: "36px", xs: "28px", sm: "32px"},
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "1.2",
            fontFamily: "Manrope",
            textAlign: "right",
            textTransform: "uppercase",
        }}>
          <Box component="span" sx={{ color: "#321338", fontWeight: 500 }}>
            Card{" "}
          </Box>
          <Box component="span" sx={{ color: "#9484ba", fontWeight: 500 }}>
            processing
          </Box>
        </Typography>
      </Box>

      <Grid container spacing={1.5} sx={{ 
        width: "100%",
        display: "flex",
        flexDirection: {xs: "column", md: "row"},
        alignItems: "stretch",
        alignSelf: "stretch",
        gap: "6px,"
        }}
        >
        {paymentSections.map((section) => (
          <Grid size={{xs: 12, sm: 12, md: 4}} key={section.id} 
          width={"100%"} height={"100%"} sx={{ display: "flex" }} 
          >
            <Paper
              sx={{
                bgcolor: "beige.200", // beige-2
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: {sm: "54px", xs: "32px"},
                padding: {xs: "24px 20px", sm: "20px 20px 32px 20px"},
                flex: 1,
                alignSelf: "stretch",
                height: "100%",
                boxShadow: "none"
                }}
                
            >
              <Stack spacing={4} sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: {sm: "32px", xs: "0px"},
                width: "100%",
              }}>
                <Box
                  sx={{
                    display: "flex",
                    width: {sm: "48px", xs: "44px"},
                    padding: {sm: "11px 0px", xs: "10px"},
                    flexDirection: "column",
                    gap: {sm: "0px", xs: "10px"},
                    justifyContent: "center",
                    alignItems: "center",
                    aspectRatio: "1/1",
                    borderRadius: "12px",
                    backgroundColor: "#DEFB1E", 
                  }}
                >
                    <Typography
                      sx={{
                        color: "#321338", // dark-purple1
                        fontSize: {sm: "22px", xs: "20px"},
                        fontStyle: "normal",
                        fontWeight: "500",
                        lineHeight: "1.2",
                        textTransform: "uppercase"
                      }}
                    >
                      {section.id}
                    </Typography>
                </Box>

                <Typography
                  sx={{
                    color: "#321338", // dark-purple1
                    fontWeight: 500,
                    fontSize: {sm: 22, xs: 20},
                    textWrap: "wrap !important"
                  }}
                >
                  {section.title}
                </Typography>
              </Stack>

              <Stack spacing={1} alignItems="center" width={"100%"}>
                {section.methods.map((row, rowIndex) => (
                  <Grid container spacing={1} key={rowIndex} sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    width: "100%",
                    gap: "4px",
                    alignSelf: "stretch",
                  }}>
                    {row.map((method, methodIndex) => (
                      <Grid size={{xs: (12 / row.length)}} key={methodIndex} 
                      alignSelf={"stretch"}
                      sx={{height: "100%"}}
                      >
                        <Paper
                          sx={{
                            bgcolor: "#fff",
                            borderRadius: 2,
                            height: 100,
                            display: "flex",
                            alignItems: "center",
                            alignSelf: "stretch",
                            justifyContent: "center",
                            position: "relative",
                          }}
                        >
                          <Box
                            component="img"
                            src={method.image}
                            alt={method.alt}
                            sx={{
                              width: method.width,
                              height: method.height,
                              objectFit: "contain",
                            }}
                          />
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                ))}
              </Stack>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

export default CardProcessing;
